// extracted by mini-css-extract-plugin
export default {"dark":"styles_dark__Ev0yt"};